// eslint-disable-next-line no-sequences
const uploadAdapter = (options, imports) => (void imports, options)

export default uploadAdapter
